/* eslint no-undef: 0 */
export function handleDefaults(defaultObj, dynamicObj) {
    for (const key in dynamicObj) {
        defaultObj[key] = dynamicObj[key];
    }
    return defaultObj;
}

export function compareByLastName(firstCourse, secondCourse, isAscending) {
    const firstName = firstCourse.name;
    const secondName = secondCourse.name;

    if (firstName < secondName) {
        return isAscending ? 1 : -1;
    }
    if (firstName > secondName) {
        return isAscending ? -1 : 1;
    }
    return 0;
}

export function isEmptyString(str) {
    return (!str || str.length === 0);
}

export const curriculumTypeOptions = [
    { value: 'Global', key: '1' },
    { value: 'Country Specific', key: '0' }
];

export const convertByteToMegabyte = ({ bytes }) => (bytes / (1024 ** 2));



// WEBPACK FOOTER //
// ./app/helpers/utils.js